<template>
  <el-dialog
    :title="'回复'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="40%"
  >
    <el-form
      :model="commentForm"
      :rules="rules"
      ref="commentForm"
      label-width="100px"
      class="demo-commentForm"
    >
      <el-form-item label="用户名">
        <div v-html="this.commentForm.username"></div>
      </el-form-item>
      <el-form-item label="订单号" prop="orderid">
        <div>{{ this.commentForm.orderid }}</div>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input
          v-model.trim="commentForm.content"
          :rows="5"
          maxlength="800"
          show-word-limit
          type="textarea"
        ></el-input>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">回复</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
//import { mapGetters } from "vuex";
export default {
  props: ["comment"],
  data() {
    return {
      commentForm: {
        orderid: this.comment ? this.comment.orderid : "",
        username: this.comment ? this.comment.username : "",
        content: ""
      },
      rules: {}
    };
  },

  methods: {
    submitForm() {
      if (this.commentForm.content == "") {
        alert("请输入内容！");
        return;
      }
      let commentEntity = {
        content: this.commentForm.content,
        orderid: this.commentForm.orderid,
        username: "客服"
      };
      this.$axios(this.$urlMapping["回复评论"], {
        data: commentEntity
        // eslint-disable-next-line no-unused-vars
      }).then(() => {
        this.$notifySuccess();
        this.$emit("closeForm");
        this.$emit("onSubmit");
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
  }
};
</script>

<style lang="less" scoped></style>
